import { post, get } from './client'

/**
 * 通用二次验证
 * POST /api/verify
 */
export async function verifyApi(params: { method: '2fa' | 'passkey'; code?: string }): Promise<void> {
  return post('/api/verify', params)
}

/**
 * Passkey 验证发起
 * POST /api/user/passkey/verify/begin
 */
export async function passkeyVerifyBeginApi(): Promise<{ options: unknown }> {
  return post('/api/user/passkey/verify/begin')
}

/**
 * Passkey 验证完成
 * POST /api/user/passkey/verify/finish
 */
export async function passkeyVerifyFinishApi(payload: unknown): Promise<void> {
  return post('/api/user/passkey/verify/finish', payload)
}

/**
 * 2FA 状态
 * GET /api/user/2fa/status
 */
export async function get2FAStatusSimpleApi(): Promise<{ enabled: boolean }> {
  return get('/api/user/2fa/status')
}

/**
 * Passkey 状态
 * GET /api/user/passkey
 */
export async function getPasskeyStatusSimpleApi(): Promise<{ enabled: boolean }> {
  return get('/api/user/passkey')
}
